// NodeDateRangeField.jsx

import React from 'react';

// CSS
import './NodeDateRangeField.css';

// Components
import NodeDateRangeInput from 'node/form/fields/daterange/NodeDateRangeInput';
import NodeTemporalReadOnlyValue from 'node/form/fields/utilities/NodeTemporalReadOnlyValue';

/**
 * NodeDateRangeField
 *
 * Displays a schema-driven date range field with inline start/end controls.
 * In readOnly / previewMode: friendly label (e.g. Jul 28, 2026 – Aug 3, 2026).
 *
 * @param {object} value - Current field value.
 * @param {Function} onChange - Callback when date range changes.
 * @param {boolean} [readOnly=false]
 * @param {boolean} [previewMode=false]
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeDateRangeField = ({
  value,
  onChange,
  readOnly = false,
  previewMode = false,
}) => {
  const isReadOnly = Boolean(readOnly || previewMode);

  if (isReadOnly) {
    return (
      <div className="node-date-range-field-container is-readonly">
        <NodeTemporalReadOnlyValue value={value} fieldType="daterange" />
      </div>
    );
  }

  return (
    <div className="node-date-range-field-container">
      <div className="node-date-range-field-form">
        <div className="node-date-range-field-connector" />
        <div className="node-date-range-field-picker">
          <NodeDateRangeInput
            value={value}
            autoFillEnd
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

NodeDateRangeField.displayName = 'NodeDateRangeField';

export default NodeDateRangeField;
